import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import ResizeObserver from 'resize-observer-polyfill';
window.ResizeObserver = ResizeObserver;
window.$ = window.jQuery = require('jquery');
require('owl.carousel');
require('jquery-validation');
require('@fancyapps/fancybox');
require('@fancyapps/fancybox/dist/jquery.fancybox.css');

// ─── Site loader (run outside DOM-ready so it kicks off ASAP) ───
(function () {
    const MIN_DISPLAY = 600;
    const start = performance.now();

    function hide() {
        const wait = Math.max(0, MIN_DISPLAY - (performance.now() - start));
        setTimeout(() => {
            const loader = document.querySelector('[data-site-loader]');
            if (loader) loader.classList.add('is-hidden');
            document.body.classList.remove('is-loading');
            // Remove from DOM after fade completes so it can't catch focus/clicks
            setTimeout(() => { if (loader && loader.parentNode) loader.parentNode.removeChild(loader); }, 700);
        }, wait);
    }

    if (document.readyState === 'complete') hide();
    else window.addEventListener('load', hide);

    // Safety net — never let the loader sit forever
    setTimeout(hide, 5000);
})();

$(function () {

    // ─── Hero slider ────────────────────────────────────────────
    const $hero = $('[data-hero-slider]');
    if ($hero.length) {
        $hero.owlCarousel({
            loop: true,
            items: 1,
            margin: 0,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 6000,
            autoplayHoverPause: false,
            smartSpeed: 1200,
        });

        const $dots = $('[data-hero-dots] .hero__dot');
        $hero.on('changed.owl.carousel', function (e) {
            const i = e.relatedTarget.relative(e.item.index);
            $dots.removeClass('is-active').eq(i).addClass('is-active');
        });
        $dots.on('click', function () {
            $hero.trigger('to.owl.carousel', [$(this).index(), 600]);
        });
    }

    // ─── Header scroll state ───────────────────────────────────
    const $header = $('[data-site-header]');
    const onScroll = () => $header.toggleClass('is-scrolled', window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // ─── Smooth scroll for in-page links ───────────────────────
    function scrollToHash(hash) {
        const target = hash && hash.length > 1 ? document.querySelector(hash) : null;
        if (!target) return false;
        const headerH = document.querySelector('[data-site-header]')?.offsetHeight || 0;
        const y = target.getBoundingClientRect().top + window.pageYOffset - headerH + 1;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        return true;
    }

    function isHomePath(pathname) {
        const normalize = (path) => path.replace(/\/+$/, '') || '/';
        const currentPath = window.location.pathname;
        const currentDir = currentPath.endsWith('/') ? currentPath : currentPath.replace(/\/[^/]*$/, '/');
        const homePath = normalize(currentDir + 'index.html');
        const targetPath = normalize(pathname);
        return targetPath === normalize(currentPath) || targetPath === homePath;
    }

    $(document).on('click', 'a[href*="#"]', function (e) {
        const href = this.getAttribute('href') || '';
        if ($(this).is('[data-fancybox]')) return;
        let url;

        try {
            url = new URL(href, window.location.href);
        } catch (error) {
            return;
        }

        const hash = url.hash;
        if (!hash || hash.length < 2) return;
        if (url.origin !== window.location.origin) return;

        if (!isHomePath(url.pathname)) return;

        if (!document.querySelector(hash)) {
            e.preventDefault();
            window.location.href = url.pathname + hash;
            return;
        }

        e.preventDefault();

        // Mobil menü açıkken (ör. menü içindeki "İletişim" butonu) önce menüyü
        // kapat, kapanma animasyonu bitmeden kaydırma başlatma — yoksa hedef
        // bölüme (#contact formu) inmeden duruyor.
        const menuWasOpen = document.querySelector('[data-mobile-menu]')?.classList.contains('is-open');
        closeMobileMenu();

        if (menuWasOpen) {
            setTimeout(() => scrollToHash(hash), 420);
        } else {
            scrollToHash(hash);
        }

        if (history.replaceState) history.replaceState(null, '', hash);
    });

    // Honour an incoming #hash on first paint (after layout settles)
    if (window.location.hash) {
        setTimeout(() => scrollToHash(window.location.hash), 1000);
    }

    // ─── Mobile menu ───────────────────────────────────────────
    const $menu = $('[data-mobile-menu]');
    const $toggle = $('[data-menu-toggle]');
    const $close = $('[data-menu-close]');

    function openMobileMenu() {
        $menu.addClass('is-open').attr('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    }
    function closeMobileMenu() {
        $menu.removeClass('is-open').attr('aria-hidden', 'true');
        document.body.style.overflow = '';
    }
    $toggle.on('click', openMobileMenu);
    $close.on('click', closeMobileMenu);
    $(document).on('keydown', (e) => { if (e.key === 'Escape') closeMobileMenu(); });

    // ─── Gallery lightbox (Fancybox) ───────────────────────────
    if ($.fancybox) {
        $.fancybox.defaults.buttons = ['zoom', 'slideShow', 'fullScreen', 'close'];
        $.fancybox.defaults.loop = true;
        $.fancybox.defaults.transitionEffect = 'fade';
        $.fancybox.defaults.animationEffect = 'fade';

        const $kvkkLinks = $('.kvkk-modal-link');
        const isMobilePdfView = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;

        if (isMobilePdfView) {
            $kvkkLinks
                .removeAttr('data-fancybox data-type')
                .attr({ target: '_blank', rel: 'noopener' })
                .on('click', function (e) {
                    e.preventDefault();
                    window.open(this.href, '_blank', 'noopener');
                });
        } else {
            $kvkkLinks.fancybox({
                touch: false,
                autoFocus: false,
                backFocus: false,
                buttons: false,
                smallBtn: true,
                hideScrollbar: true,
                afterClose: function () {
                    if (document.activeElement) document.activeElement.blur();
                },
            });
        }
    }

    // ─── Back-to-top ───────────────────────────────────────────
    const $backTop = $('[data-back-to-top]');
    if ($backTop.length) {
        const heroEl = document.querySelector('#hero');

        if (heroEl && 'IntersectionObserver' in window) {
            // Home: visible only when hero has fully left the viewport
            const io = new IntersectionObserver(([entry]) => {
                $backTop.toggleClass('is-visible', !entry.isIntersecting);
            }, { threshold: 0 });
            io.observe(heroEl);
        } else {
            // Legal pages (no #hero) or no IO support: scroll threshold
            const threshold = heroEl ? heroEl.offsetTop + heroEl.offsetHeight - 100 : 500;
            const check = () => $backTop.toggleClass('is-visible', window.scrollY > threshold);
            check();
            window.addEventListener('scroll', check, { passive: true });
        }

        $backTop.on('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    }

    // ─── Cookie banner ──────────────────────────────────────────
    const COOKIE_KEY = 'sd_cookie_consent_dismissed';
    const $cookie = $('[data-cookie-banner]');
    if ($cookie.length) {
        let dismissed = false;
        try { dismissed = localStorage.getItem(COOKIE_KEY) === '1'; } catch (_) {}

        if (!dismissed) {
            setTimeout(() => $cookie.addClass('is-visible').attr('aria-hidden', 'false'), 900);
        } else {
            $cookie.remove();
        }

        $cookie.on('click', '[data-cookie-dismiss]', function () {
            $cookie.removeClass('is-visible').attr('aria-hidden', 'true');
            try { localStorage.setItem(COOKIE_KEY, '1'); } catch (_) {}
            setTimeout(() => $cookie.remove(), 700);
        });
    }

    // ─── Apartment selector ─────────────────────────────────────
    const aptSelect = document.querySelector('[data-apt-select]');
    const aptSelectTrigger = aptSelect && aptSelect.querySelector('[data-apt-select-trigger]');
    const aptSelectList = aptSelect && aptSelect.querySelector('[data-apt-select-list]');

    function closeAptSelect() {
        if (!aptSelect) return;

        aptSelect.classList.remove('is-open');
        if (aptSelectTrigger) aptSelectTrigger.setAttribute('aria-expanded', 'false');
    }

    if (aptSelect && aptSelectTrigger) {
        aptSelectTrigger.addEventListener('click', function (e) {
            e.stopPropagation();

            const isOpen = aptSelect.classList.toggle('is-open');
            aptSelectTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            if (!isOpen || !aptSelectList) return;

            // Bring the selected option into view — the list holds 60+ types
            const active = aptSelectList.querySelector('.apt-select__option.is-active');
            if (active) {
                aptSelectList.scrollTop = active.offsetTop - (aptSelectList.clientHeight - active.offsetHeight) / 2;
            }
        });

        document.addEventListener('click', function (e) {
            if (!aptSelect.contains(e.target)) closeAptSelect();
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' || e.key === 'Esc') closeAptSelect();
        });
    }

    // ─── Plan images: prefetch + paint only once decoded ────────
    // Panels are display:none until picked, which stops lazy loading from
    // ever fetching them. Without this the download starts on click and the
    // PNG paints in line by line.
    const aptPanels = document.querySelector('.apt-panels');
    const aptTargets = Array.prototype.map.call(
        document.querySelectorAll('[data-apt-target]'),
        (el) => el.getAttribute('data-apt-target')
    );
    const aptPrefetched = new Set();

    function aptPlanImage(target) {
        const panel = document.querySelector(`[data-apt-panel="${target}"]`);
        return panel ? panel.querySelector('.apt-visual img') : null;
    }

    // Hidden panels keep their image in data-src, so promoting it to src is
    // what actually starts the download
    function prefetchAptPlan(target) {
        const img = aptPlanImage(target);
        if (!img) return;

        const src = img.getAttribute('data-src');
        if (!src || aptPrefetched.has(src)) return;

        aptPrefetched.add(src);
        img.setAttribute('src', src);
        img.removeAttribute('data-src');
    }

    // Users step through neighbouring types, so warm those too
    function prefetchAptNeighbours(target) {
        const i = aptTargets.indexOf(target);
        if (i < 0) return;
        [i - 2, i - 1, i + 1, i + 2].forEach((n) => {
            if (n >= 0 && n < aptTargets.length) prefetchAptPlan(aptTargets[n]);
        });
    }

    function revealAptPlan(target) {
        prefetchAptPlan(target);

        const img = aptPlanImage(target);
        if (!img) return;

        if (img.complete && img.naturalWidth) {
            img.classList.add('is-loaded');
            return;
        }

        img.classList.remove('is-loaded');
        const done = () => img.classList.add('is-loaded');
        if (img.decode) img.decode().then(done, done);
        else img.addEventListener('load', done, { once: true });
    }

    if (aptPanels) {
        // Opt into the fade from JS so images stay visible without it
        aptPanels.classList.add('is-img-fade');

        const activePanel = aptPanels.querySelector('.apt-panel.is-active');
        const activeTarget = activePanel && activePanel.getAttribute('data-apt-panel');
        if (activeTarget) {
            revealAptPlan(activeTarget);
            prefetchAptNeighbours(activeTarget);
        }

        // Hover/focus on desktop and the first touch on mobile both land
        // well before the click, so the image is usually already in cache
        $(document).on('mouseenter focus touchstart', '[data-apt-target]', function () {
            prefetchAptPlan($(this).data('apt-target'));
        });
    }

    $(document).on('click', '[data-apt-target]', function () {
        const target = $(this).data('apt-target');

        $('[data-apt-target]').removeClass('is-active').attr('aria-selected', 'false');
        $(this).addClass('is-active').attr('aria-selected', 'true');
        $('[data-apt-select-value]').text($(this).find('.apt-select__option-text').text());
        closeAptSelect();

        $('[data-apt-panel]').removeClass('is-active');
        $(`[data-apt-panel="${target}"]`).addClass('is-active');

        revealAptPlan(target);
        prefetchAptNeighbours(target);
    });

    // ─── Google Map ─────────────────────────────────────────────
    const GOOGLE_MAP_CONFIG = {
        apiKey: 'AIzaSyBSNva8JEuoV0kDEfiRwE_sQFF2Xa0fMzo',
        lat: 40.99960069289627,
        lng: 29.2419016,
        zoom: 19,
    };

    const GOOGLE_MAP_STYLE = [
        { elementType: 'geometry', stylers: [{ color: '#ebe3cd' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#523735' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f1e6' }] },
        { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#c9b2a6' }] },
        { featureType: 'administrative.land_parcel', elementType: 'geometry.stroke', stylers: [{ color: '#dcd2be' }] },
        { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#ae9e90' }] },
        { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#dfd2ae' }] },
        { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#dfd2ae' }] },
        { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#93817c' }] },
        { featureType: 'poi.park', elementType: 'geometry.fill', stylers: [{ color: '#a5b076' }] },
        { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#447530' }] },
        { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#f5f1e6' }] },
        { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#fdfcf8' }] },
        { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#f8c967' }] },
        { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#e9bc62' }] },
        { featureType: 'road.highway.controlled_access', elementType: 'geometry', stylers: [{ color: '#e98d58' }] },
        { featureType: 'road.highway.controlled_access', elementType: 'geometry.stroke', stylers: [{ color: '#db8555' }] },
        { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#806b63' }] },
        { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#dfd2ae' }] },
        { featureType: 'transit.line', elementType: 'labels.text.fill', stylers: [{ color: '#8f7d77' }] },
        { featureType: 'transit.line', elementType: 'labels.text.stroke', stylers: [{ color: '#ebe3cd' }] },
        { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#dfd2ae' }] },
        { featureType: 'water', elementType: 'geometry.fill', stylers: [{ color: '#b9d3c2' }] },
        { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#92998d' }] },
    ];

    const mapEl = document.querySelector('[data-google-map]');
    if (mapEl && GOOGLE_MAP_CONFIG.apiKey) {
        const canvas = mapEl.querySelector('[data-google-map-canvas]');

        if (canvas) {
            window.initSancakDoraMap = function () {
                const position = { lat: GOOGLE_MAP_CONFIG.lat, lng: GOOGLE_MAP_CONFIG.lng };

                const map = new window.google.maps.Map(canvas, {
                    center: position,
                    zoom: GOOGLE_MAP_CONFIG.zoom,
                    disableDefaultUI: true,
                    zoomControl: true,
                    styles: GOOGLE_MAP_STYLE,
                });

                new window.google.maps.Marker({
                    map,
                    position,
                    title: 'Sancak Dora',
                });
            };

            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(GOOGLE_MAP_CONFIG.apiKey)}&callback=initSancakDoraMap&v=weekly`;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        }
    }

    // ─── Reveal-on-scroll for major blocks ─────────────────────
    gsap.utils.toArray('.section-title, .section-label, .feature-card, .location__item, .about__card, .gallery__cell, .social__cell, .contact__info-item').forEach((el) => {
        gsap.fromTo(el,
            { y: 30, opacity: 0 },
            {
                y: 0,
                opacity: 1,
                duration: 0.9,
                ease: 'power2.out',
                scrollTrigger: { trigger: el, start: 'top 85%', once: true },
            }
        );
    });

    // ─── Anti-autofill: readonly stays until user interacts ────
    $(document).on('focus mousedown touchstart', '[data-no-autofill]', function () {
        $(this).removeAttr('readonly');
    });

    // ─── Contact form validation ───────────────────────────────
    const $form = $('[data-contact-form]');
    if ($form.length && $.fn.validate) {
        $.validator.addMethod('phoneTR', function (value, element) {
            return this.optional(element) || /^05\d{9}$/.test(value);
        }, 'Telefon numarası 05 ile başlamalı ve 11 hane olmalıdır.');

        $form.on('input', 'input[name="phone"]', function () {
            this.value = this.value.replace(/\D/g, '').slice(0, 11);
        });

        $form.validate({
            errorElement: 'span',
            errorClass: 'contact-field__error',
            ignore: ':hidden:not(select):not([name="kvkk"]):not([name="etk"])',
            rules: {
                name:    { required: true, minlength: 2 },
                phone:   { required: true, phoneTR: true },
                email:   { required: true, email: true },
                subject: { required: true },
                kvkk:    { required: true },
                etk:     { required: true },
            },
            messages: {
                name:    { required: 'Lütfen adınızı ve soyadınızı giriniz.', minlength: 'En az 2 karakter olmalı.' },
                phone:   { required: 'Lütfen telefon numaranızı giriniz.', phoneTR: 'Telefon numarası 05 ile başlamalı ve 11 hane olmalıdır.' },
                email:   { required: 'Lütfen e-posta adresinizi giriniz.', email: 'Geçerli bir e-posta adresi giriniz.' },
                subject: { required: 'Lütfen bir konu seçiniz.' },
                kvkk:    { required: 'Devam etmek için KVKK aydınlatma metnini onaylamanız gerekir.' },
                etk:     { required: 'Devam etmek için ticari elektronik ileti onayını vermeniz gerekir.' },
            },
            errorPlacement: function (error, element) {
                if (element.attr('name') === 'kvkk' || element.attr('name') === 'etk') {
                    const $consent = element.closest('.contact-consent');
                    $consent.find('.contact-field__error').remove();
                    error.appendTo($consent);
                    return;
                }
                const $field = element.closest('.contact-field');
                $field.find('.contact-field__error').remove();
                error.appendTo($field);
            },
            highlight: function (element) {
                const $el = $(element);
                if ($el.attr('name') === 'kvkk' || $el.attr('name') === 'etk') $el.closest('.contact-consent').addClass('is-invalid');
                else $el.closest('.contact-field').addClass('is-invalid');
            },
            unhighlight: function (element) {
                const $el = $(element);
                if ($el.attr('name') === 'kvkk' || $el.attr('name') === 'etk') $el.closest('.contact-consent').removeClass('is-invalid');
                else $el.closest('.contact-field').removeClass('is-invalid');
            },
            submitHandler: function (form) {
                const $btn = $(form).find('button[type=submit]');
                $btn.prop('disabled', true).text('Gönderiliyor…');

                const payload = {
                    name:    form.name.value.trim(),
                    phone:   form.phone.value.trim(),
                    email:   form.email.value.trim(),
                    subject: form.subject.value,
                    message: form.message.value.trim(),
                    kvkk:    form.kvkk.checked,
                    etk:     form.etk.checked,
                };

                fetch('https://vtfas6egu6a5jgxxi546e7w3fq0uklsi.lambda-url.eu-central-1.on.aws/', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload),
                })
                .then(res => res.json().then(data => ({ ok: res.ok, data })))
                .then(({ ok, data }) => {
                    if (!ok || data?.code !== 200) {
                        throw new Error(data?.error || 'Send failed');
                    }
                    $btn.text('Teşekkürler ✓');
                    form.reset();
                    setTimeout(() => $btn.prop('disabled', false).text('Gönder'), 3000);
                })
                .catch(err => {
                    console.error('Contact form error:', err);
                    $btn.text('Hata oluştu — tekrar deneyin');
                    setTimeout(() => $btn.prop('disabled', false).text('Gönder'), 3000);
                });

                return false;
            },
        });
    }
});
